<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button *ngIf="flashcard && !isAudioPlaying()" (click)="vocalize()">
        <ion-icon *ngIf="!loadingAudio" name="volume-high-outline"></ion-icon>
        <ion-spinner *ngIf="loadingAudio"></ion-spinner>
      </ion-button>
      <ion-button *ngIf="flashcard && isAudioPlaying()" (click)="stopAudio()">
        <ion-icon name="stop-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ng-container *ngIf="flashcard && flashcard.root_word">
    <ion-grid>
    <ion-row>
        <ion-col size="12">
            <h1>{{ flashcard.root_word }}</h1>
            <h3>{{ flashcard.translation }}</h3>
            <div *ngFor="let example of flashcard.examples; let i = index">
            <p><strong>{{ example }}</strong></p>
            <p>{{ flashcard.example_translations[i] }}</p>
            </div>
            <a (click)="goToArticle()"> {{ 'FLASHCARD_DETAILS.VIEW_ARTICLE' | translate }} </a>
        </ion-col>
    </ion-row>
    <!--
    <ion-row class="details-row">
        <ion-col size="12">
            <h4>{{ 'FLASHCARD_DETAILS.CARD_DETAILS' | translate }}:</h4>
        </ion-col>
        <ion-col size="12" class="status-col">
            <strong>{{ 'FLASHCARD_DETAILS.DUE_DATE' | translate }}:</strong>
            <p>{{ flashcard.dueDate?.toDate() | date:'medium' }}</p>
        </ion-col>
        <ion-col size="12" class="status-col">
            <strong>{{ 'FLASHCARD_DETAILS.CREATED_AT' | translate }}:</strong>
            <p>{{ flashcard.createdAt?.toDate() | date:'medium' }}</p>
        </ion-col>
        <ion-col size="12" class="status-col">
            <a (click)="goToArticle()"> {{ 'FLASHCARD_DETAILS.VIEW_ARTICLE' | translate }} </a>
        </ion-col>
    </ion-row>-->
    </ion-grid>
  </ng-container>
</ion-content>